module.exports = __webpack_public_path__ + "img/icon_map_1_on_101.f0cd021a.png";